import React from 'react';
import { OrderSide } from './types';
import { PositionInfo } from '../../types/portfolio';
import { formatCurrency } from '../../utils/formatNumber';
import PositionSelect from './PositionSelect';

interface OrderFormFieldsProps {
  side: OrderSide;
  symbol: string;
  quantity: string;
  loading: boolean;
  positions: PositionInfo[];
  positionsLoading: boolean;
  selectedPosition: PositionInfo | null;
  currentPrice: number | null;
  priceLoading: boolean;
  onSideChange: (side: OrderSide) => void;
  onSymbolChange: (symbol: string) => void;
  onQuantityChange: (quantity: string) => void;
  onSelectPosition: (position: PositionInfo) => void;
}

const OrderFormFields: React.FC<OrderFormFieldsProps> = ({
  side,
  symbol,
  quantity,
  loading,
  positions,
  positionsLoading,
  selectedPosition,
  currentPrice,
  priceLoading,
  onSideChange,
  onSymbolChange,
  onQuantityChange,
  onSelectPosition,
}) => (
    <>
      <div className="form-group">
        <label>주문 유형</label>
        <div className="radio-group">
          <label className="radio-label">
            <input
              type="radio"
              name="side"
              value="buy"
              checked={side === 'buy'}
              onChange={(e) => onSideChange(e.target.value as OrderSide)}
            />
            매수
          </label>
          <label className="radio-label">
            <input
              type="radio"
              name="side"
              value="sell"
              checked={side === 'sell'}
              onChange={(e) => onSideChange(e.target.value as OrderSide)}
            />
            매도
          </label>
        </div>
      </div>
      <div className="form-group">
        <label>자산 타입</label>
        <div className="radio-group"><span className="radio-label">주식</span></div>
        <small className="form-hint">
          수동 주문은 주식 주문 경로만 지원합니다. 암호화폐 기능은 폐기되었습니다.
        </small>
      </div>
      {side === 'sell' && (
        <div className="positions-select">
          <label>보유 포지션 선택 (주식)</label>
          <PositionSelect
            positions={positions}
            positionsLoading={positionsLoading}
            symbol={symbol}
            onSelectPosition={onSelectPosition}
          />
        </div>
      )}
      <div className="form-group">
        <label htmlFor="symbol">종목 코드</label>
        <input
          id="symbol"
          type="text"
          value={symbol}
          onChange={(e) => onSymbolChange(e.target.value)}
          placeholder="AAPL"
          className="form-input"
          disabled={loading}
        />
        {priceLoading && <small className="form-hint">현재가 조회 중...</small>}
        {currentPrice && !priceLoading && (
          <small className="form-hint">현재가: {formatCurrency(currentPrice)}</small>
        )}
      </div>
      <div className="form-group">
        <label htmlFor="quantity">수량</label>
        <input
          id="quantity"
          type="number"
          step="0.000001"
          value={quantity}
          max={side === 'sell' && selectedPosition ? selectedPosition.qty : undefined}
          onChange={(e) => onQuantityChange(e.target.value)}
          placeholder="0.000000"
          className="form-input"
          disabled={loading}
        />
        {side === 'sell' && selectedPosition && (
          <small className="form-hint">최대: {formatQuantity(selectedPosition.qty)}</small>
        )}
      </div>
    </>
);

function formatQuantity(value: number): string {
  return value.toLocaleString('ko-KR', { maximumFractionDigits: 6 });
}

export default OrderFormFields;
